var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    typography = _ref.typography,
    borders = _ref.borders,
    colors = _ref.colors,
    breakpoints = _ref.breakpoints;
  return {
    rootBorderWidth: borders.widthSmall,
    rootBorderColor: colors.contrasts.grey1111,
    instructionsPaddingTopBottom: spacing.medium,
    instructionsPaddingLeftRight: spacing.large,
    instructionsBorderWidth: borders.widthSmall,
    instructionsBorderColor: colors.contrasts.grey1111,
    instructionsHeaderPadding: spacing.xSmall,
    instructionsHeaderFontWeight: typography.fontWeightBold,
    infoPaddingTopBottom: spacing.small,
    infoPaddingLeftRight: spacing.medium,
    infoBackgroundColor: colors.contrasts.grey1111,
    headerPaddingTop: spacing.xSmall,
    headerPaddingBottom: spacing.small,
    titleFontSize: typography.fontSizeMedium,
    titleFontWeight: typography.fontWeightBold,
    itemsPadding: spacing.small,
    phoneBreakPoint: "max-width: ".concat(breakpoints.medium),
    phoneInstructionsPaddingTopBottom: spacing.medium,
    phoneInstructionsPaddingLeftRight: spacing.small,
    phoneInfoPadding: spacing.small,
    phoneConnectingLinesBorderWidth: borders.widthSmall,
    phoneConnectingLinesBorderColor: colors.contrasts.grey1214,
    phoneConnectingLinesMargin: spacing.small
  };
};
export default generateComponentTheme;